import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Observable } from 'rxjs';
import { ResponsiveService } from '../../services/reponsive.service';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/boutons/button/button.component';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectClientPlan } from '../../store/client/client.selects';
import { Plan } from '../../class/plan.class';
import { selectJobsByStatusCount } from '../../store/jobs/jobs.selects';

@Component({
    selector: 'app-dashboard-content',
    imports: [LucideAngularModule, RouterLink, NgClass, AsyncPipe, TranslateModule, ButtonComponent, DatePipe],
    templateUrl: './dashboard-content.component.html',
    styleUrl: './dashboard-content.component.scss'
})
export class DashboardContentComponent {

    constructor(
        private responsiveService: ResponsiveService,
        private store: Store,
        public router:Router
    ) { }

    smallScreen$: Observable<boolean> = this.responsiveService.small$;
    mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
    largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

    clientPlan$: Observable<Plan | null> = this.store.select(selectClientPlan);
    jobCompletedCount$: Observable<number> = this.store.select(selectJobsByStatusCount('COMPLETED'));
    jobWaitingResponseCount$: Observable<number> = this.store.select(selectJobsByStatusCount('WAITING_RESPONSE'));
    jobRunningCount$: Observable<number> = this.store.select(selectJobsByStatusCount('IN_PROGRESS'));
}
